"use client";

import { c as _c } from "react/compiler-runtime";
import { useShowCinemaFilter } from "src/lib/program/useShowCinemaFilter";
import styles from "./CinemaFilterSlot.module.css";
import CurrentFilter from "src/components/filterselector/CurrentFilter";

//#region [Props]
type CinemaFilterSlotProps = {
  isAdFree?: boolean;
  adFreeSkin?: string | null;
};
//#endregion

//#region [Component]
export default function CinemaFilterSlot(t0) {
  const $ = _c(1);
  const {
    isAdFree,
    adFreeSkin
  } = t0;
  const showCinemaFilter = useShowCinemaFilter(isAdFree, adFreeSkin);
  if (!showCinemaFilter) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.CinemaFilter}><CurrentFilter hideFamilyFilter={true} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
}
//#endregion